import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
let store = new Vuex.Store({
    state: {

        token:'',
        phone:'',
        total:'',
        courselist:[],
        whid:'',


        video:'',
        ppt:'',
    },
    getters: {
        
    },
    mutations: {
        setToken(state,val) {
            state.token = val
        },
        setPhone(state,val) {
            state.phone = val
        },
        setTotal(state,val) {
            state.total = val
        },
        setCourselist(state,val) {
            state.courselist= val
        },
        setWhid(state,val) {
            state.whid = val
        },
        setVideo(state,val) {
            state.video = val
        },
        setPpt(state,val) {
            state.ppt = val
        },
    },
    actions: {

    },

})

export default store